import { Autocomplete } from "@material-ui/lab";
import { CircularProgress, TextField } from "@material-ui/core";
import React, { useEffect } from "react";
import withIntl from "../../../utils/withIntl";
import articlesStore from "../../../store/articles/ArticlesStore";
import Grid from "@material-ui/core/Grid";
import { Remove } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Articlegroup } from "../../../store/articles/models/Articlegroup";

const useStyles = makeStyles({
  rootItem: { padding: 0 },
});

function ArticleBatchEditSelectArticles(props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [selectedItems, setSelectedItems] = React.useState([]);

  let loading = open && options.length === 0;

  const search = (searchValue) => {
    if (!articlesStore.articles) {
      return [];
    }

    let searchResults = Object.keys(articlesStore.articlegroups).reduce((articlegroups, articlegroup_id) => {
      if (articlegroups.length > 9) {
        return articlegroups;
      }
      let searchValues = searchValue.split(/\s/);

      let articlegroup = articlesStore.articlegroups[articlegroup_id];
      if (selectedItems.indexOf(articlegroup) > -1) {
        return articlegroups;
      }
      if (
        searchValues.every((value) => {
          if (value.length === 0) {
            return true;
          }
          if (articlegroup.name.toLowerCase().includes(value.toLowerCase())) {
            return true;
          }
          return false;
        })
      ) {
        articlegroups.push(articlegroup);
      }

      return articlegroups;
    }, []);

    searchResults = searchResults.concat(
      Object.keys(articlesStore.articles).reduce((articles, articleId) => {
        if (articles.length + searchResults.length > 9) {
          return articles;
        }
        let searchValues = searchValue.split(/\s/);

        let article = articlesStore.articles[articleId];
        if (
          selectedItems.some((selectedItem) => {
            if (selectedItem instanceof Articlegroup) {
              if (selectedItem.id === article.articlegroup_id) {
                return true;
              }
            } else if (selectedItem.id === article.id) {
              return true;
            }
            return false;
          })
        ) {
          return articles;
        }
        if (
          searchValues.every((value) => {
            if (value.length === 0) {
              return true;
            }
            if (
              article.name
                .toLowerCase()
                .includes(
                  value.toLowerCase()
                ) /*||
              article.plu.toLowerCase().includes(value.toLowerCase())*/
            ) {
              return true;
            }
            if (article.plu.toLowerCase().includes(value.toLowerCase())) {
              return true;
            }
            return false;
          })
        ) {
          articles.push(article);
        }

        return articles;
      }, [])
    );

    return searchResults;
  };

  useEffect(() => {
    if (selectedOption) {
      setSelectedOption(null);
      const oldValues = [...selectedItems];
      oldValues.push(selectedOption);
      setSelectedItems(oldValues);
      props.setSelectedItems(oldValues);
    }
  }, [selectedOption]);

  useEffect(() => {
    let active = true;

    (async () => {
      const options = await search(searchValue);
      if (active) {
        setOptions(options);
      }
    })();

    return () => {
      active = false;
    };
  }, [searchValue, selectedItems, selectedOption]);

  React.useEffect(() => {
    if (!open) {
      // setOptions([]);
    }
  }, [open]);

  const handleRemoveFromItems = (itemName) => {
    const oldSelectedItems = [...selectedItems];
    const index = oldSelectedItems.findIndex((item) => item.name === itemName);
    oldSelectedItems.splice(index, 1);
    setSelectedItems(oldSelectedItems);
  };

  return (
    <>
      <Autocomplete
        open={open}
        onOpen={(e) => {
          setOpen(true);
        }}
        onClose={(e) => {
          if (e?.type === "blur") {
            setOpen(false);
          }
        }}
        filterOptions={(x) => x}
        onChange={(e, value) => {
          if (value) {
            setSelectedOption(value);
          }
        }}
        inputValue={searchValue}
        onInputChange={(event, value) => {
          if (event?.type === "change") {
            setSearchValue(value);
          }
        }}
        getOptionSelected={(option, value) => {
          return typeof option === typeof value && option.id === value.id;
        }}
        getOptionLabel={(option) => option.name}
        options={options}
        loading={loading}
        renderInput={(params) => (
          <TextField
            {...params}
            label={props.intl.formatMessage({ id: "Search" })}
            helperText={props.intl.formatMessage({ id: "select_articlegroups_or_articles_to_batch-update" })}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
      <Grid container>
        {selectedItems.map((item) => (
          <>
            <Grid item xs={10}>
              <Typography variant={"caption"} classes={{ root: classes.rootItem }}>
                {item.name}
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => handleRemoveFromItems(item.name)}>
                <Remove size={"small"} />
              </IconButton>
            </Grid>
          </>
        ))}
      </Grid>
    </>
  );
}

export default withIntl(ArticleBatchEditSelectArticles);
